<app-contract-table
  [contracts]="tables$ | async"
  [contractsLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  (filterData)="filterSearchData($event)"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
  (callbackResult)="getCallBackResult($event)"
></app-contract-table>
